import {
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  Typography,
  useTheme,
} from "@mui/material";
import { v4 as uuid } from "uuid";
import { Avatar, CheckIcon, SearchInput } from "components";
import { useFetchResourcesByPermissions, useGetAllResources } from "controller";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import React, { useCallback, useMemo, useState } from "react";
import { emptyStringHandler } from "utilz/helpers";
import {
  addAssignee,
  selectedCustomerId,
  selectedResourceList,
  selectedServiceType,
} from "../store/assigneeStore";

export const AssignessResourcesList = () => {
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState<string | null>(null);
  const customerId = useAtomValue(selectedCustomerId);
  const serviceType = useAtomValue(selectedServiceType);
  const { data: resources } = useFetchResourcesByPermissions({
    sortColumn: "users.first_name",
    customer_id: customerId,
    // filter: [{ column: "u.is_verified", operator: "=", value: true }],
    filter: [],
    serviceType: serviceType,
    ...(searchQuery ? { searchQuery: searchQuery } : {}),
  });

  // const { data: resourcess } = useGetAllResources({
  //   sortColumn: "users.first_name",
  //   filter: [{ column: "is_locked", operator: "=", value: false }],
  //   perPageCount: 40,
  //   ...(searchQuery ? { searchQuery: searchQuery } : {}),
  // });

  return (
    <Box
      sx={{
        display: "block",
        width: "224px",
        height: "100%",
        borderRight: `1px solid ${theme.palette.neutral["015"]}`,
      }}
    >
      <Box sx={{ flexShrink: 0 }}>
        <Box
          sx={{
            p: "12px 16px",
            borderBottom: `1px solid ${theme.palette.neutral["015"]}`,
          }}
        >
          <Typography variant="body-large">Resources</Typography>
        </Box>
        <SearchInput
          fullWidth
          placeholder="Search resources"
          name="search"
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{
            p: "12px 16px",
          }}
        />
      </Box>
      <Box
        sx={{
          flex: 1,
          overflowY: "scroll",
          height: "80%",
        }}
      >
        <ResourceList resources={resources} />
      </Box>
    </Box>
  );
};

const ResourceList = ({ resources }: any) => (
  <List
    dense
    sx={{
      width: "100%",
      flexGrow: 1,
      // height: "640px",
    }}
  >
    {resources?.result?.map((resource: any) => {
      return <ResourceListItem resource={resource} key={resource.mapping_id} />;
    })}
  </List>
);

const isResourceSelected = ({
  assignees,
  resourceId,
}: {
  assignees: Array<string>;
  resourceId: string;
}) => {
  return assignees.some((assignee) => assignee === resourceId);
};

const ResourceListItem = ({ resource }: { resource: any }) => {
  const [selectedResourceArray] = useAtom(selectedResourceList);
  const addNewAssignee = useSetAtom(addAssignee);
  const theme = useTheme();
  const isSelected = useMemo(
    () =>
      isResourceSelected({
        assignees: selectedResourceArray,
        resourceId: resource.mapping_id,
      }),
    [resource.mapping_id, selectedResourceArray],
  );
  const fullName = `${emptyStringHandler(
    resource.first_name,
  )} ${emptyStringHandler(resource.last_name)}`;

  const handleItemClick = () => {
    if (!isSelected) {
      addNewAssignee({
        uuid: uuid(),
        resource_id: resource.mapping_id,
        first_name: resource.first_name,
        last_name: resource.last_name,
        profile_image: resource.profile_image,
        start_time: null,
        end_time: null,
      });
    }
  };
  return (
    <ListItem
      key={resource.mapping_id}
      secondaryAction={
        <>
          {isSelected ? (
            <Box
              sx={{
                width: "20px",
                height: "20px",
                borderRadius: "100%",
                bgcolor: theme.palette.primitive.brand.purple[700],
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CheckIcon
                sx={{ width: "12px", height: "12px" }}
                fontSize="small"
                htmlColor="#FFF"
              />
            </Box>
          ) : (
            <></>
          )}
        </>
      }
      disablePadding
    >
      <ListItemButton
        onClick={handleItemClick}
        disableRipple
        sx={{
          minHeight: "42px",
          paddingY: "8px",
          bgcolor: isSelected
            ? theme.palette.primitive.brand.purple[25]
            : "transparent",
          ":hover": {
            bgcolor: theme.palette.neutral["B-005"],
          },
        }}
      >
        <ListItemAvatar>
          <Avatar fullname={fullName} src={resource.profile_image} />
        </ListItemAvatar>
        <Typography variant="body-medium">{fullName}</Typography>
      </ListItemButton>
    </ListItem>
  );
};
